@if (isVisible()) {
  <div
    class="purchase-batch-action-bar"
    role="region"
    aria-label="Ações em lote">
    <div class="batch-action-bar-content flex-row items-center space-between gap-16">
      <div class="counter-section flex-row items-center gap-8">
        <span class="count-badge">{{ selectedCount() }}</span>
        <span class="count-text">
          {{ 'item' | pluralizador: selectedCount() }}
          {{ 'selecionado' | pluralizador: selectedCount() }}
        </span>
      </div>

      <div class="actions-section flex-row items-center gap-8">
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="approve-button"
          (click)="approve.emit()">
          <mat-icon>check</mat-icon>
          Aprovar selecionados
        </button>

        <button
          mat-stroked-button
          color="warn"
          type="button"
          class="decline-button"
          (click)="decline.emit()">
          <mat-icon>close</mat-icon>
          Recusar selecionados
        </button>

        <button
          mat-button
          type="button"
          class="clear-button"
          (click)="clearSelection.emit()">
          Limpar seleção
        </button>
      </div>
    </div>
  </div>
}
